<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { getStr } from '../../../common/util';
  import ProductPrice from '../../common/components/ProductPrice.svelte';
  export let models;
  export let activeModel;
  export let showPriceForComingSoon;

  let dispatcher = createEventDispatcher();

  function modelClick(model) {
    dispatcher('modelClick', model);
  }
</script>

<div class="d-flex flex-column c_preordermodel">
  <div class="c_variant-title">{@html getStr('extra.preorder.model.text')}</div>
  <div class="d-flex gap-4 flex-wrap">
    {#each models as model, index}
      {#if model?.product}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          tabindex={index}
          role="button"
          class="c_variantbox model d-flex flex-column gap-1 gap-md-3 {activeModel === model.uid ? 'active' : ''}"
          class:c_noprice={!showPriceForComingSoon}
          on:click={() => modelClick(model)}
        >
          {model?.title}
          {#if showPriceForComingSoon}
            <span class="price"
              >{@html getStr('extra.preorder.from.text')}
              <ProductPrice price={model?.startFromPrice} cssClass="c_variant-price" />
            </span>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
</div>
